// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #0f0f1e;
  color: #ffffff;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Main Content Layout with Sidebar */
.main-content {
  margin-left: 260px;
  min-height: 100vh;
  padding: 2rem;
  transition: margin-left 0.3s ease;
  flex: 1 1;
  width: calc(100% - 260px);
  max-width: 100%;
}

@media (max-width: 1024px) {
  .main-content {
    margin-left: 0;
    padding: 1.5rem;
    padding-top: 4rem;
    width: 100%;
  }
}

/* Page Header */
.page-header {
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.page-header p {
  color: #8b8b9a;
  margin-top: 0.5rem;
  font-size: 0.95rem;
}

/* Card Styles */
.card {
  background: linear-gradient(145deg, #1a1a2e, #16213e);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid rgba(88, 101, 242, 0.1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.card-header h2 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Grid Layout */
.grid {
  display: grid;
  gap: 1.5rem;
}

.grid-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

@media (max-width: 1200px) {
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-3 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .grid-2,
  .grid-3,
  .grid-4 {
    grid-template-columns: 1fr;
  }
}

/* Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.65rem 1.25rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  text-decoration: none;
}

.btn-primary {
  background: #5865F2;
  color: white;
}

.btn-primary:hover {
  background: #4752c4;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(88, 101, 242, 0.3);
}

.btn-success {
  background: #43b581;
  color: white;
}

.btn-success:hover {
  background: #3ca374;
  transform: translateY(-2px);
}

.btn-danger {
  background: #ef4444;
  color: white;
}

.btn-danger:hover {
  background: #dc2626;
  transform: translateY(-2px);
}

.btn-ghost {
  background: transparent;
  color: #8b8b9a;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.btn-ghost:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.2);
}

/* Form Styles */
.form-group {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #b4b4c4;
  margin-bottom: 0.5rem;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #ffffff;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #5865F2;
  box-shadow: 0 0 0 3px rgba(88, 101, 242, 0.2);
}

.form-input::placeholder {
  color: #6b6b7b;
}

/* Badge Styles */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge-success {
  background: rgba(67, 181, 129, 0.2);
  color: #43b581;
}

.badge-warning {
  background: rgba(250, 166, 26, 0.2);
  color: #faa61a;
}

.badge-danger {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.badge-info {
  background: rgba(88, 101, 242, 0.2);
  color: #5865F2;
}

/* Table Styles */
.table-container {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

th {
  background: rgba(0, 0, 0, 0.2);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8b8b9a;
}

tr:hover td {
  background: rgba(88, 101, 242, 0.05);
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  gap: 20px;
}

.spinner {
  border: 4px solid rgba(88, 101, 242, 0.1);
  border-left-color: #5865F2;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 3rem 2rem;
  color: #8b8b9a;
}

.empty-state svg {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-state h3 {
  color: #ffffff;
  margin-bottom: 0.5rem;
}

/* Stat Cards */
.stat-card {
  background: linear-gradient(145deg, #1a1a2e, #16213e);
  border-radius: 12px;
  padding: 1.25rem;
  border: 1px solid rgba(88, 101, 242, 0.1);
}

.stat-card .stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  margin-bottom: 1rem;
}

.stat-card .stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.25rem;
}

.stat-card .stat-label {
  font-size: 0.85rem;
  color: #8b8b9a;
}

/* Utility Classes */
.text-center { text-align: center; }
.text-right { text-align: right; }
.text-muted { color: #8b8b9a; }
.text-success { color: #43b581; }
.text-warning { color: #faa61a; }
.text-danger { color: #ef4444; }
.text-primary { color: #5865F2; }

.mt-1 { margin-top: 0.5rem; }
.mt-2 { margin-top: 1rem; }
.mt-3 { margin-top: 1.5rem; }
.mt-4 { margin-top: 2rem; }

.mb-1 { margin-bottom: 0.5rem; }
.mb-2 { margin-bottom: 1rem; }
.mb-3 { margin-bottom: 1.5rem; }
.mb-4 { margin-bottom: 2rem; }

.flex { display: flex; }
.flex-center { align-items: center; justify-content: center; }
.flex-between { justify-content: space-between; }
.flex-wrap { flex-wrap: wrap; }
.gap-1 { gap: 0.5rem; }
.gap-2 { gap: 1rem; }
.gap-3 { gap: 1.5rem; }

/* ===== Shared Component Styles ===== */

/* Page Header with Actions */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Add Button */
.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.add-btn:hover {
  background: #4752c4;
  transform: translateY(-1px);
}

.add-btn.secondary {
  background: #2f3136;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.add-btn.secondary:hover {
  background: #36393f;
  border-color: rgba(255, 255, 255, 0.2);
}

/* Tab Bar */
.tab-bar {
  display: flex;
  gap: 4px;
  margin-bottom: 24px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 4px;
}

.tab-btn {
  background: transparent;
  color: #8b8b9a;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.tab-btn:hover {
  color: #dcddde;
  background: rgba(255, 255, 255, 0.05);
}

.tab-btn.active {
  background: #5865f2;
  color: white;
  font-weight: 600;
}

/* Filter Tabs */
.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-tabs button {
  background: rgba(0, 0, 0, 0.2);
  color: #8b8b9a;
  border: 1px solid transparent;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.filter-tabs button:hover {
  color: #dcddde;
  background: rgba(255, 255, 255, 0.05);
}

.filter-tabs button.active {
  background: #5865f2;
  color: white;
  font-weight: 600;
}

/* Data Table */
.data-table-container {
  background: linear-gradient(145deg, #1a1a2e, #16213e);
  border-radius: 12px;
  border: 1px solid rgba(88, 101, 242, 0.1);
  overflow: hidden;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table thead th {
  background: rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  text-align: left;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8b8b9a;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.data-table tbody td {
  padding: 12px 16px;
  color: #dcddde;
  font-size: 0.9rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.data-table tbody tr:hover td {
  background: rgba(88, 101, 242, 0.05);
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

/* Icon Buttons */
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-btn.edit,
.icon-btn.success {
  color: #43b581;
}

.icon-btn.edit:hover,
.icon-btn.success:hover {
  background: rgba(67, 181, 129, 0.15);
}

.icon-btn.delete,
.icon-btn.danger {
  color: #f04747;
}

.icon-btn.delete:hover,
.icon-btn.danger:hover {
  background: rgba(240, 71, 71, 0.15);
}

.actions-cell {
  display: flex;
  gap: 4px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal {
  background: linear-gradient(145deg, #1a1a2e, #16213e);
  border: 1px solid rgba(88, 101, 242, 0.15);
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
  font-size: 1.25rem;
}

.form-group label {
  display: block;
  color: #b4b4c4;
  margin-bottom: 5px;
  font-size: 0.85rem;
  font-weight: 600;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #5865F2;
  box-shadow: 0 0 0 3px rgba(88, 101, 242, 0.2);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #6b6b7b;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.form-row {
  display: flex;
  gap: 12px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.05);
  color: #8b8b9a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.submit-btn:hover {
  background: #4752c4;
}

/* Slider */
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  outline: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5865f2;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(88, 101, 242, 0.3);
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5865f2;
  cursor: pointer;
  border: none;
}

/* No Data / Empty */
.no-data {
  text-align: center;
  color: #8b8b9a;
  padding: 40px;
}

/* Week Grid (Week Planning) */
.week-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}

@media (max-width: 1024px) {
  .week-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 600px) {
  .week-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;aACW;AACb;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,SAAO;EACP,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,qDAAqD;EACrD,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oBAAoB;AACpB,eAAe,kBAAkB,EAAE;AACnC,cAAc,iBAAiB,EAAE;AACjC,cAAc,cAAc,EAAE;AAC9B,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;AAChC,eAAe,cAAc,EAAE;AAC/B,gBAAgB,cAAc,EAAE;;AAEhC,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;;AAE1B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;;AAE7B,QAAQ,aAAa,EAAE;AACvB,eAAe,mBAAmB,EAAE,uBAAuB,EAAE;AAC7D,gBAAgB,8BAA8B,EAAE;AAChD,aAAa,eAAe,EAAE;AAC9B,SAAS,WAAW,EAAE;AACtB,SAAS,SAAS,EAAE;AACpB,SAAS,WAAW,EAAE;;AAEtB,wCAAwC;;AAExC,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,qDAAqD;EACrD,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,wDAAwD;AAC1D;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #0f0f1e;\n  color: #ffffff;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Main Content Layout with Sidebar */\n.main-content {\n  margin-left: 260px;\n  min-height: 100vh;\n  padding: 2rem;\n  transition: margin-left 0.3s ease;\n  flex: 1;\n  width: calc(100% - 260px);\n  max-width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .main-content {\n    margin-left: 0;\n    padding: 1.5rem;\n    padding-top: 4rem;\n    width: 100%;\n  }\n}\n\n/* Page Header */\n.page-header {\n  margin-bottom: 2rem;\n}\n\n.page-header h1 {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.page-header p {\n  color: #8b8b9a;\n  margin-top: 0.5rem;\n  font-size: 0.95rem;\n}\n\n/* Card Styles */\n.card {\n  background: linear-gradient(145deg, #1a1a2e, #16213e);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid rgba(88, 101, 242, 0.1);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.card-header h2 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Grid Layout */\n.grid {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.grid-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.grid-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.grid-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n@media (max-width: 1200px) {\n  .grid-4 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .grid-3 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .grid-2,\n  .grid-3,\n  .grid-4 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.65rem 1.25rem;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  text-decoration: none;\n}\n\n.btn-primary {\n  background: #5865F2;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #4752c4;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(88, 101, 242, 0.3);\n}\n\n.btn-success {\n  background: #43b581;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #3ca374;\n  transform: translateY(-2px);\n}\n\n.btn-danger {\n  background: #ef4444;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #dc2626;\n  transform: translateY(-2px);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: #8b8b9a;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.btn-ghost:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n/* Form Styles */\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-label {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #b4b4c4;\n  margin-bottom: 0.5rem;\n}\n\n.form-input,\n.form-select,\n.form-textarea {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: #5865F2;\n  box-shadow: 0 0 0 3px rgba(88, 101, 242, 0.2);\n}\n\n.form-input::placeholder {\n  color: #6b6b7b;\n}\n\n/* Badge Styles */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.badge-success {\n  background: rgba(67, 181, 129, 0.2);\n  color: #43b581;\n}\n\n.badge-warning {\n  background: rgba(250, 166, 26, 0.2);\n  color: #faa61a;\n}\n\n.badge-danger {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.badge-info {\n  background: rgba(88, 101, 242, 0.2);\n  color: #5865F2;\n}\n\n/* Table Styles */\n.table-container {\n  overflow-x: auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth, td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\nth {\n  background: rgba(0, 0, 0, 0.2);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #8b8b9a;\n}\n\ntr:hover td {\n  background: rgba(88, 101, 242, 0.05);\n}\n\n/* Loading States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 80vh;\n  gap: 20px;\n}\n\n.spinner {\n  border: 4px solid rgba(88, 101, 242, 0.1);\n  border-left-color: #5865F2;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 3rem 2rem;\n  color: #8b8b9a;\n}\n\n.empty-state svg {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.empty-state h3 {\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n/* Stat Cards */\n.stat-card {\n  background: linear-gradient(145deg, #1a1a2e, #16213e);\n  border-radius: 12px;\n  padding: 1.25rem;\n  border: 1px solid rgba(88, 101, 242, 0.1);\n}\n\n.stat-card .stat-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.stat-card .stat-value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.25rem;\n}\n\n.stat-card .stat-label {\n  font-size: 0.85rem;\n  color: #8b8b9a;\n}\n\n/* Utility Classes */\n.text-center { text-align: center; }\n.text-right { text-align: right; }\n.text-muted { color: #8b8b9a; }\n.text-success { color: #43b581; }\n.text-warning { color: #faa61a; }\n.text-danger { color: #ef4444; }\n.text-primary { color: #5865F2; }\n\n.mt-1 { margin-top: 0.5rem; }\n.mt-2 { margin-top: 1rem; }\n.mt-3 { margin-top: 1.5rem; }\n.mt-4 { margin-top: 2rem; }\n\n.mb-1 { margin-bottom: 0.5rem; }\n.mb-2 { margin-bottom: 1rem; }\n.mb-3 { margin-bottom: 1.5rem; }\n.mb-4 { margin-bottom: 2rem; }\n\n.flex { display: flex; }\n.flex-center { align-items: center; justify-content: center; }\n.flex-between { justify-content: space-between; }\n.flex-wrap { flex-wrap: wrap; }\n.gap-1 { gap: 0.5rem; }\n.gap-2 { gap: 1rem; }\n.gap-3 { gap: 1.5rem; }\n\n/* ===== Shared Component Styles ===== */\n\n/* Page Header with Actions */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.header-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n/* Add Button */\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n  transform: translateY(-1px);\n}\n\n.add-btn.secondary {\n  background: #2f3136;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.add-btn.secondary:hover {\n  background: #36393f;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n/* Tab Bar */\n.tab-bar {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 24px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  padding: 4px;\n}\n\n.tab-btn {\n  background: transparent;\n  color: #8b8b9a;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.tab-btn:hover {\n  color: #dcddde;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.tab-btn.active {\n  background: #5865f2;\n  color: white;\n  font-weight: 600;\n}\n\n/* Filter Tabs */\n.filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filter-tabs button {\n  background: rgba(0, 0, 0, 0.2);\n  color: #8b8b9a;\n  border: 1px solid transparent;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.filter-tabs button:hover {\n  color: #dcddde;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.filter-tabs button.active {\n  background: #5865f2;\n  color: white;\n  font-weight: 600;\n}\n\n/* Data Table */\n.data-table-container {\n  background: linear-gradient(145deg, #1a1a2e, #16213e);\n  border-radius: 12px;\n  border: 1px solid rgba(88, 101, 242, 0.1);\n  overflow: hidden;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table thead th {\n  background: rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #8b8b9a;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.data-table tbody td {\n  padding: 12px 16px;\n  color: #dcddde;\n  font-size: 0.9rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n}\n\n.data-table tbody tr:hover td {\n  background: rgba(88, 101, 242, 0.05);\n}\n\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Icon Buttons */\n.icon-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-btn.edit,\n.icon-btn.success {\n  color: #43b581;\n}\n\n.icon-btn.edit:hover,\n.icon-btn.success:hover {\n  background: rgba(67, 181, 129, 0.15);\n}\n\n.icon-btn.delete,\n.icon-btn.danger {\n  color: #f04747;\n}\n\n.icon-btn.delete:hover,\n.icon-btn.danger:hover {\n  background: rgba(240, 71, 71, 0.15);\n}\n\n.actions-cell {\n  display: flex;\n  gap: 4px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modal {\n  background: linear-gradient(145deg, #1a1a2e, #16213e);\n  border: 1px solid rgba(88, 101, 242, 0.15);\n  border-radius: 12px;\n  padding: 24px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n  font-size: 1.25rem;\n}\n\n.form-group label {\n  display: block;\n  color: #b4b4c4;\n  margin-bottom: 5px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.3);\n  color: #fff;\n  font-size: 14px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #5865F2;\n  box-shadow: 0 0 0 3px rgba(88, 101, 242, 0.2);\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: #6b6b7b;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.form-row {\n  display: flex;\n  gap: 12px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #8b8b9a;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n/* Slider */\n.slider {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 8px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  outline: none;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #5865f2;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(88, 101, 242, 0.3);\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #5865f2;\n  cursor: pointer;\n  border: none;\n}\n\n/* No Data / Empty */\n.no-data {\n  text-align: center;\n  color: #8b8b9a;\n  padding: 40px;\n}\n\n/* Week Grid (Week Planning) */\n.week-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 8px;\n}\n\n@media (max-width: 1024px) {\n  .week-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .week-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
